import styled from 'styled-components';

export const EditIconWrapper = styled.div`
    pointer-events: none;
    position: relative;
    top: 12px;

    opacity: 0;
    transform: translateX(-8px);
    transition:
        opacity 0.2s ease-in-out,
        transform 0.2s ease-in-out;

    @media (max-width: 768px) {
        opacity: 0.25;
        transform: translateX(0px);
    }
`;
